// extracted by mini-css-extract-plugin
module.exports = {"overlay":"DialogPrompt__overlay___25Vqg","prompt":"DialogPrompt__prompt___19Hz9","message":"DialogPrompt__message___wFDDe","confirmButton":"DialogPrompt__confirmButton___VN5N_"};